import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "../components/Layout";

export default function Admin() {
  const [log, setLog] = useState([]);
  const { user } = useAuth();

  useEffect(() => { api.get("/audit-log").then((r) => setLog(r.data)); }, []);

  return (
    <div className="canvas-grain min-h-screen pb-16" data-testid="admin-page">
      <PageHeader overline="Administration" title="Governance & Audit Trail"
        subtitle="Every score change, scenario approval and target-model approval is recorded with the acting user." />
      <div className="px-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-white border border-black/10 rounded-sm p-5">
          <p className="text-[11px] uppercase tracking-[0.15em] text-black/50 mb-3">Current user</p>
          <p className="font-display font-bold text-lg tracking-tight">{user?.name}</p>
          <p className="text-[13px] text-black/60">{user?.email}</p>
          <span className="inline-block mt-2 text-[11px] uppercase tracking-wider bg-[#0A0A0A] text-[#D4AF37] px-2 py-1 rounded-sm">{user?.role}</span>
          <div className="mt-5 pt-4 border-t border-black/8 text-[12px] text-black/55 space-y-1.5">
            <p>● JWT authentication with httpOnly cookies</p>
            <p>● AI recommendations require named human approval</p>
            <p>● Copilot answers use workspace evidence only</p>
            <p>● SSO, workspaces and granular RBAC arrive in Phase 3</p>
          </div>
        </div>
        <div className="lg:col-span-2 bg-white border border-black/10 rounded-sm overflow-hidden">
          <div className="px-5 py-3 bg-[#0A0A0A] text-[#D4AF37] text-[11px] uppercase tracking-[0.15em]">Audit trail</div>
          {log.length === 0 && <p className="p-5 text-[13px] text-black/45">No audited actions yet. Adjust a diagnostic score or approve a scenario to see entries here.</p>}
          <div className="divide-y divide-black/5 max-h-[60vh] overflow-y-auto">
            {log.map((e) => (
              <div key={e.id} className="px-5 py-3 flex items-center justify-between text-[13px]" data-testid="audit-log-entry">
                <div>
                  <span className="font-mono text-[11px] bg-black/5 px-1.5 py-0.5 rounded-sm mr-2">{e.action}</span>
                  {e.detail}
                </div>
                <div className="text-right text-[11px] text-black/45 shrink-0 ml-4">
                  <p>{e.user}</p>
                  <p>{new Date(e.ts).toLocaleString()}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
